import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbookAir: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMacbookAir"><Path d="M1 18H9L10 18.5H14L15 18H23V20H1V18Z" fill="currentColor"/><Path d="M2 4V16.5H22V4H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacbookAir;
